export const adaptWorkFlowStartV2_2 = (result) => {
    if (!result || !result.data) {
        console.warn('[adaptWorkFlowStartV2_2] Respuesta inválida o sin data:', result);
        return {
            response: {},
            status: '1',
            msg: 'Adapter: respuesta vacía o sin propiedad data',
        };
    }

    const {
        workflow             = {},
        hasSavedPayway       = '0',
        hasUserSusc          = null,
        selectedPaymentMethod= null,
        newWorkflow          = null,
    } = result.data;

    // Shape 1: { data: { list: [...], ... } }           → nuevo shape plano
    // Shape 2: { data: { workflow: { listBuyLinks: [...] }, ... } } → shape con workflow
    const list = result.data.list || workflow.listBuyLinks || [];

    return {
        response: {
            ...result.data,
            workflow,
            hasSavedPayway,
            hasUserSusc,
            selectedPaymentMethod,
            list,
            newWorkflow,
        },
        status: '0',
        msg: 'OK',
    };
};


// WEBPACK FOOTER //
// ./src/requests/adapters/payway/workFlowStartV2_2.adapter.js